// @ constants
const actionTypes = require('constants/actionTypes');

// @ actions
const { outdateGlobalPosition } = require('actions/myGlobalPosition');

const { EURO_TEXT, 
        API_ENTERPRISE_NUMBER, 
        API_CENTER, 
        OPENYOUNG_CHORE_APPROVED, 
        OPENYOUNG_CHORE_PENDING } = require('constants/index');

// @ commons
const { APIPost } = require('utilities/APIRequestHelper');
const { getLanguage } = require('core/i18n').i18n;
const apiURLBuilder = require('core/apiURLBuilder.js');
const get = require('lodash/object/get');
const set = require('lodash/object/set');

// @actions
const openYoungCardChoreStatusUpdate = require('./openYoungCardChoreStatusUpdate');

const setRemark = (remark) => ({
    type: actionTypes.OPENYOUNG_CARD_PAYMENT_CHORE_SET_REMARK,
    payload: {
        remark
    }
});

const setAmount = (amount, amountisDirty = false) => ({
    type: actionTypes.OPENYOUNG_CARD_PAYMENT_CHORE_SET_AMOUNT,
    payload: {
        amount,
        amountisDirty
    }
});

const setAccount = (fromAccount) => ({
    type: actionTypes.OPENYOUNG_CARD_PAYMENT_CHORE_SET_ACCOUNT,
    payload: {
        fromAccount
    }
});

const validateStep = (step) => ({
    type: actionTypes.OPENYOUNG_CARD_PAYMENT_CHORE_VALIDATE_STEP,
    payload: {
        step
    }
});

const setVisibleStep = (step) => ({
    type: actionTypes.OPENYOUNG_CARD_PAYMENT_CHORE_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const resetState = () => ({
    type: actionTypes.OPENYOUNG_CARD_PAYMENT_CHORE_RESET
});

const setWillCancel = (willCancel) => ({
    type: actionTypes.OPENYOUNG_CARD_PAYMENT_CHORE_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const setAccountAvailableBalance = (accountAvailableBalance) => ({
    type: actionTypes.OPENYOUNG_CARD_PAYMENT_CHORE_SET_ACCOUNT_AVAILABLE_BALANCE,
    payload: {
        accountAvailableBalance
    }
});

const setCardAvailableBalance = (cardAvailableBalance) => ({
    type: actionTypes.OPENYOUNG_CARD_PAYMENT_CHORE_SET_CARD_AVAILABLE_BALANCE,
    payload: {
        cardAvailableBalance
    }
});

const setAllAccountsToInactive = () =>({
    type: actionTypes.OPENYOUNG_CARD_PAYMENT_CHORE_SET_ALL_ACCOUNTS_TO_INACTIVE
});

const baseRequestData = (immAccount, immCard, amount) => {
    const immEcardInfo = immCard.getIn(['extra', 'eCardInfo']);

    const requestData = {
        query: {
            contratoTarjeta: {
                numerodecontrato: immCard.getIn(['contract', 'number']),
                producto: immCard.getIn(['contract', 'product'])
            },
            cuentaAsociada: {
                numerodecontrato: immAccount.get('contractNumber'),
                producto: immAccount.get('product')
            },
            numTarjeta: immCard.get('number'),
            datosTarjeta: {
                saldoActualPrepago: {
                    divisa: immEcardInfo.getIn(['saldoActualPrepago', 'divisa'])  || immCard.getIn(['availableBalance', 'currency']),
                    importe: immEcardInfo.getIn(['saldoActualPrepago', 'importe']) || immCard.getIn(['availableBalance', 'amount']),
                },
                estandarDeReferencia: {
                    codigodeestandar: immCard.getIn(['criteria', 'c1', 'estand']),
                    subtipodeproducto: {
                        subtipodeproducto: immCard.getIn(['criteria', 'c1', 'subtipoproducto']),
                        tipodeproducto: {
                            tipodeproducto: immCard.getIn(['contract', 'product'])
                        }
                    }
                },
                tipoLiquidacion: immEcardInfo.get('tipoLiquidacion'),
                formaDePago: immEcardInfo.get('formaDePago'),
                nomTitular: immEcardInfo.get('nomTitular'),
                descNomProdISBAN: immEcardInfo.get('descNomProdISBAN')
            },
            importeOperacion: {
                divisa: immCard.getIn(['availableBalance', 'currency']),
                importe: amount
            }
        }
    }
    return requestData;
}

const confirmationRequestData = (immAccount, immCard, dataToken, amount, datosPreliq) => {
    const requestData = {
        query: Object.assign(baseRequestData(immAccount, immCard, amount)["query"],{
            dataToken,
            datosPreliq
        })
    };
    return requestData;
}

const paymentTransferConfirmation = (immAccount, amount, immCard, confirmationComment, choreAssignmentId, choreDetail) => (dispatch) => {   
    const requestData = baseRequestData(immAccount, immCard, amount);
    requestData.query.importeOperacion.importe = amount
    dispatch(openYoungCardChoreStatusUpdate.openYoungChoreStatusUpdateRequest());

    if(choreDetail.getIn(['choreStatus','choreStatusId']) !== OPENYOUNG_CHORE_PENDING) {
        const error = Error("Invalid chore status");
        dispatch(openYoungCardChoreStatusUpdate.openYoungChoreStatusUpdateFailure(error));
        return;
    }
    return APIPost({
        dispatch,
        url: apiURLBuilder.getURL('eCardChargeValidation'),
        params: requestData
    })
    .then((response) => {
        const datosPreliq = response["datosPreliq"];
        const id = 7;
        const requestData = {
            query: {
                originAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${immAccount.get('product')}${immAccount.get('contractNumber')}`,
                ammount: amount, 
                pan: immCard.get('number','').toString().replace(/\s/g,''), 
                currency: EURO_TEXT
            }
        }
        const language = getLanguage().toLowerCase();
        return APIPost({
            dispatch,
            url: apiURLBuilder.getURL('signaturePatternRequestConfig', {id, language}),
            params: requestData
        })
        .then(response => {
            const requestData = confirmationRequestData(immAccount, immCard, response["dataToken"], amount, datosPreliq);
            set(requestData,'query.datosPreliq.importeOperacion.importe',
            get(requestData,'query.datosPreliq.importeOperacion.importe') || 0);
            set(requestData,'query.datosPreliq.importeTotalOperacion.importe',
            get(requestData,'query.datosPreliq.importeTotalOperacion.importe') || 0);
            set(requestData,'query.datosPreliq.estandarDeReferencia.subtipodeproducto.tipodeproducto.tipodeproducto',
            get(requestData,'query.datosPreliq.estandarDeReferencia.subtipodeproducto.tipodeproducto.tipodeproducto') || 
            immCard.getIn(['contract', 'product']) || "   ");

            return APIPost({
                dispatch,
                url: apiURLBuilder.getURL('eCardChargeConfirmation'),
                params: requestData
            })
            .then(() => {
                const choreStatusDetails = {
                    choreAssignmentId: choreAssignmentId,
                    confirmationComment,
                    choreStatusId: OPENYOUNG_CHORE_APPROVED,
                    reward: amount || 0
                }
                
                dispatch(openYoungCardChoreStatusUpdate.updateChoreStatus(choreStatusDetails));
                dispatch(outdateGlobalPosition());
            })
            .catch( error => {
                dispatch(openYoungCardChoreStatusUpdate.openYoungChoreStatusUpdateFailure(error));
                throw error;
            });
        })
        .catch( error => {
            dispatch(openYoungCardChoreStatusUpdate.openYoungChoreStatusUpdateFailure(error));
            throw error;
        });
    })
    .catch( error => {
        dispatch(openYoungCardChoreStatusUpdate.openYoungChoreStatusUpdateFailure(error));
        throw error;
    });
}

module.exports = {
    paymentTransferConfirmation,
    resetState,
    setAccount,
    setAccountAvailableBalance,
    setAllAccountsToInactive,
    setAmount,
    setCardAvailableBalance,
    setRemark,
    setVisibleStep,
    setWillCancel,
    validateStep
}
